
      var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgHey = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 201,
  height: 201,
  viewBox: "0 0 100 100",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M26.39 22.346c-4.8 2.8 0 11.833 3 16-13-1-9.5 8-7 13 14.5 25 14 22 22 28 9.5 4.5 19.5 0 24-2.5 20.5-18.5 7.5-34.5 3.5-41-2.4-7.2-8.333-7-11-6l-4.5 5c-2.166-3.5-6.9-11.3-8.5-14.5-4.5-4-9.5 2-11.5 4-1.5-3-5-3.5-10-2z",
  fill: "var(--theme-bright, #e3d2e9)"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M40.385 17.47a8.056 8.056 0 0 1 10.863 2.716l.137.228 12.634 21.878a1.738 1.738 0 0 1-2.925 1.872l-.086-.133-12.633-21.877a4.58 4.58 0 0 0-8.04 4.375l.109.2 8.212 14.222a1.738 1.738 0 0 1-2.925 1.871l-.086-.133-8.212-14.222a8.053 8.053 0 0 1 2.952-10.996z",
  fill: "var(--theme-primary, #810ea9)"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M30.94 18.32a8.055 8.055 0 0 1 6.829 3.785l.147.247 10.739 18.596a1.738 1.738 0 0 1-2.925 1.872l-.085-.133-10.74-18.598a4.579 4.579 0 0 0-8.047 4.363l.117.215 12.002 20.785a1.738 1.738 0 0 1-2.925 1.872l-.085-.134-12.002-20.783A8.053 8.053 0 0 1 30.94 18.32z",
  fill: "var(--theme-primary, #810ea9)"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M64.824 26.477a8.055 8.055 0 0 1 6.829 3.785l.147.246 6.317 10.939a26.997 26.997 0 0 1 .004 27.004 27.007 27.007 0 0 1-46.55.387l-.23-.39L19.34 47.663a8.053 8.053 0 0 1 2.952-10.996 8.056 8.056 0 0 1 10.863 2.715l.137.228 5.686 9.845a1.738 1.738 0 0 1-2.926 1.872l-.085-.134-5.684-9.844a4.58 4.58 0 0 0-8.041 4.376l.109.2L34.352 66.71a23.53 23.53 0 0 0 40.759.003 23.52 23.52 0 0 0 .217-23.136l-.221-.392-6.318-10.94a4.58 4.58 0 0 0-8.047 4.364l.117.215 3.158 5.47c.48.83.196 1.894-.636 2.374-5.211 3.008-6.996 9.67-3.988 14.88a1.738 1.738 0 1 1-3.01 1.738c-3.634-6.292-1.967-14.19 3.616-18.524l.191-.146-2.34-4.053a8.053 8.053 0 0 1-.154-7.788l.149-.27a8.055 8.055 0 0 1 6.98-4.028zM23.543 71.123a1.738 1.738 0 0 1 2.374.639 33.492 33.492 0 0 0 9.937 10.811 1.738 1.738 0 1 1-1.982 2.856 36.966 36.966 0 0 1-10.968-11.933 1.738 1.738 0 0 1 .64-2.373zM64.84 16.266a18.153 18.153 0 0 1 15.726 9.081 1.738 1.738 0 1 1-3.01 1.737 14.678 14.678 0 0 0-12.716-7.342 1.738 1.738 0 0 1 0-3.476z",
  fill: "var(--theme-primary, #810ea9)"
})));

      const __svgRaw = "<svg width=\"201\" height=\"201\" viewBox=\"0 0 100 100\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n    <path d=\"M26.39 22.346c-4.8 2.8 0 11.833 3 16-13-1-9.5 8-7 13 14.5 25 14 22 22 28 9.5 4.5 19.5 0 24-2.5 20.5-18.5 7.5-34.5 3.5-41-2.4-7.2-8.333-7-11-6l-4.5 5c-2.166-3.5-6.9-11.3-8.5-14.5-4.5-4-9.5 2-11.5 4-1.5-3-5-3.5-10-2z\" fill=\"var(--theme-bright, #e3d2e9)\"/>\r\n    <path d=\"M40.385 17.47a8.056 8.056 0 0 1 10.863 2.716l.137.228 12.634 21.878a1.738 1.738 0 0 1-2.925 1.872l-.086-.133-12.633-21.877a4.58 4.58 0 0 0-8.04 4.375l.109.2 8.212 14.222a1.738 1.738 0 0 1-2.925 1.871l-.086-.133-8.212-14.222a8.053 8.053 0 0 1 2.952-10.996z\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n    <path d=\"M30.94 18.32a8.055 8.055 0 0 1 6.829 3.785l.147.247 10.739 18.596a1.738 1.738 0 0 1-2.925 1.872l-.085-.133-10.74-18.598a4.579 4.579 0 0 0-8.047 4.363l.117.215 12.002 20.785a1.738 1.738 0 0 1-2.925 1.872l-.085-.134-12.002-20.783A8.053 8.053 0 0 1 30.94 18.32z\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n    <path d=\"M64.824 26.477a8.055 8.055 0 0 1 6.829 3.785l.147.246 6.317 10.939a26.997 26.997 0 0 1 .004 27.004 27.007 27.007 0 0 1-46.55.387l-.23-.39L19.34 47.663a8.053 8.053 0 0 1 2.952-10.996 8.056 8.056 0 0 1 10.863 2.715l.137.228 5.686 9.845a1.738 1.738 0 0 1-2.926 1.872l-.085-.134-5.684-9.844a4.58 4.58 0 0 0-8.041 4.376l.109.2L34.352 66.71a23.53 23.53 0 0 0 40.759.003 23.52 23.52 0 0 0 .217-23.136l-.221-.392-6.318-10.94a4.58 4.58 0 0 0-8.047 4.364l.117.215 3.158 5.47c.48.83.196 1.894-.636 2.374-5.211 3.008-6.996 9.67-3.988 14.88a1.738 1.738 0 1 1-3.01 1.738c-3.634-6.292-1.967-14.19 3.616-18.524l.191-.146-2.34-4.053a8.053 8.053 0 0 1-.154-7.788l.149-.27a8.055 8.055 0 0 1 6.98-4.028zM23.543 71.123a1.738 1.738 0 0 1 2.374.639 33.492 33.492 0 0 0 9.937 10.811 1.738 1.738 0 1 1-1.982 2.856 36.966 36.966 0 0 1-10.968-11.933 1.738 1.738 0 0 1 .64-2.373zM64.84 16.266a18.153 18.153 0 0 1 15.726 9.081 1.738 1.738 0 1 1-3.01 1.737 14.678 14.678 0 0 0-12.716-7.342 1.738 1.738 0 0 1 0-3.476z\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n\r\n</svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/hey.f5030146e8b1245fb1eb02430257822c.svg"),
        {
          React: SvgHey,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      